module.exports = __webpack_public_path__ + "img/icon@2x(5).31d34dae.png";